import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {RemoveCouponPropsData} from '../../actions/coupon'
import "./style.css";

class Menu extends Component {
    constructor(props) {
        super(props)
        this.state = {};
        this.removeCouponPropsData = this.removeCouponPropsData.bind(this);
    }

    removeCouponPropsData() {
        this.props.dispatch(RemoveCouponPropsData());
    }

    render() {
        let menuItem = "";
        // if(this.props.authenticated === undefined || this.props.authenticated===false){
        //   let adminToken = sessionStorage.getItem('adminToken');
        //   if(adminToken){
        menuItem = <div className="vertical-menu">
            <img src={require("./logo.png")} className="logoimage"/>
            <Link to="/logout"> Logout </Link>
            <Link to="/changePassword"> Change Password </Link>
            {/* <Link to="/members" > Members </Link> */}
            <Link to="/studyList"> Study </Link>
            <Link to="/dashboard"> Dashboard </Link>
            <Link to="/payment"> Payment </Link>
            <Link to="/coupon" onClick={this.removeCouponPropsData}> Coupon </Link>
            <Link to="/counrty"> Country </Link>
            <Link to="/demographicsCategories"> Demographics </Link>



        </div>
        //}


//     }else{

//       let admin = sessionStorage.getItem('admin');
//       let adminPass = sessionStorage.getItem('adminPass');
//       if(admin && adminPass){
//         menuItem = <div>
//            <img src={require("./logo34.png")}  className = "logoimage"/>
//                       <Link to="/logout" > Logout </Link>
//                       <Link to="/members" > Members </Link>
//                       <Link to="/studyList" > Study </Link>
//                       <Link to="/dashboard" > Dashboard </Link>
//                    </div>

//     }
// }

        return (<div>
                <div className="adminmenubar">
                    {menuItem}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        authenticated: state.login.authenticated,
    }
}

export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./src/containers/Menu/index.js